// BookTickets/SummaryBox/SummaryTotals.tsx
import cn from 'classnames'
import styles from '../index.module.scss'
import { useBookingState } from '@booking/state/booking.context'
import type { UseSummaryData } from '../hooks/useSummaryData'
import { useTranslations } from 'next-intl'

export const SummaryTotals = ({ summaryData }: { summaryData: UseSummaryData }) => {
  const { cart, config } = useBookingState()
  const hasExtras = Boolean(config?.extras)
  const t = useTranslations('booking')

  const {
    subTotal,
    subTotalBeforeVoucher,
    discountValue,
    ticketTotal,
    hasVouchers,
    shouldDiscountPrice,
  } = summaryData

  if (!cart) return null

  return (
    <div className={styles.summary}>
      {parseInt(subTotal(), 10) !== 0 && !hasExtras && (cart?.discount || shouldDiscountPrice) && (
        <>
          <div className={cn(styles.line, styles.sub)}>
            <span className={styles.name}>{t('ticket.summaryBox.subtotal')}:</span>
            {/*hasVouchers && session && (
              <span className={styles.crossed}>{subTotalBeforeVoucher()}</span>
            )*/}
            &nbsp;
            <span className={styles.subText}>{subTotal()}</span>
          </div>
          <div className={cn(styles.line, styles.sub, styles.discount)}>
            <span className={styles.name}>{t('ticket.summaryBox.discount')}:</span>{' '}
            {discountValue()}
          </div>
        </>
      )}
      <div className={cn(styles.line, styles.total)}>
        <span className={styles.name}>{t('ticket.summaryBox.total')}:</span> {ticketTotal()}
      </div>
    </div>
  )
}
